import React from 'react';
import { Button, CUIText } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { ButtonGroup } from '../../../button-group/button-group';
import { ColorOptionProps } from '../font-drawer-types';
import { getColorDisplayName } from '../utils/color-display-name';
import styles from '../font-drawer.module.scss';

export const ColorOption = ({
  addClass = '',
  colors,
  selectedColor,
  ariaLabel,
  label,
  testId = 'color-option',
  scrollable,
  buttonGroupClick,
}: ColorOptionProps): React.ReactElement => {
  const classes = classNames(styles['color-option'], addClass);
  const buttonGroupClass = classNames(styles['button-group'], scrollable && styles['color-option-scrollable']);

  return (
    <div className={classes} data-testid={testId}>
      {label && (
        <CUIText variant="form" className={styles['label']}>
          {label}
        </CUIText>
      )}
      <ButtonGroup
        ariaLabel={ariaLabel}
        addClass={buttonGroupClass}
        defaultClickedIndex={colors.indexOf(selectedColor)}
        selectedIndex={colors.indexOf(selectedColor)}
      >
        {colors.map((colorName, index) => (
          <Button
            onClick={() => buttonGroupClick(colorName)}
            size="icon"
            aria-label={getColorDisplayName(colorName)}
            color={colorName}
            className={classNames(styles[`color-${colorName}`], styles.buttons)}
            data-testid={`color-button-${colorName}`}
            key={index}
          >
            <CUIText as="span" variant="screen-reader">
              {getColorDisplayName(colorName)}
            </CUIText>
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};
